import { Box, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { border } from '../../layout/theme/border'
import { themeColor } from '../../layout/theme/color'

interface FormSectionProps {
  title: ReactNode
  description?: ReactNode
  children: ReactNode
  /** Fields in two columns (default) or one. */
  columns?: 1 | 2
}

/**
 * Settings-style form section: title + help on the left, fields on the right.
 *
 *   Contact                 [ Naam          ] [ Telefoon ]
 *   Wie we mailen bij…      [ E-mail                     ]
 */
export const FormSection: FC<FormSectionProps> = ({ title, description, children, columns = 2 }) => (
  <Box
    sx={{
      'display': 'grid',
      'gridTemplateColumns': { xs: '1fr', lg: '240px minmax(0, 1fr)' },
      'columnGap': 5,
      'rowGap': 1.5,
      'py': 3,
      'width': '100%',
      'borderTop': `${border.thin} solid ${border.light}`,
      '&:first-of-type': { borderTop: 0, pt: 0.5 },
    }}
  >
    <Box>
      <Typography component="h3" sx={{ fontSize: 14, fontWeight: 600, color: themeColor.slate }}>{title}</Typography>
      {description && (
        <Typography sx={{ fontSize: 12.5, lineHeight: 1.5, color: themeColor.slate50, mt: 0.5 }}>{description}</Typography>
      )}
    </Box>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: columns === 2 ? 'repeat(2, minmax(0, 1fr))' : '1fr' },
        columnGap: 2,
        alignItems: 'start',
        minWidth: 0,
      }}
    >
      {children}
    </Box>
  </Box>
)
